import { useAtomValue, useSetAtom } from 'jotai';
import { selectedRoleIdAtom } from '../atoms';

export const useSelectedRoleId = () => useAtomValue(selectedRoleIdAtom);

export const useSelectedRoleIdUpdater = () => useSetAtom(selectedRoleIdAtom);
